import React from "react";
import { Shield } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative border-t border-[#1c2533] bg-[#0a0e14] px-6 lg:px-10 py-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <Shield size={16} className="text-cyan-400" strokeWidth={1.5} />
          <span className="font-mono text-[11px] tracking-[0.18em] text-slate-400">
            AL//SOC &middot; {new Date().getFullYear()} &middot; ALL SYSTEMS NOMINAL
          </span>
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-slate-500 flex items-center gap-3">
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
            UPTIME 100%
          </span>
          <span className="text-slate-700">|</span>
          <span>BUILT WITH FOCUS · INSPIRED BY THE BLUE TEAM</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
